export default __webpack_public_path__ + "locales/lo-LA/Settings.json?hash=6cc688be0503220a138840db3c502329";